import { useQuery } from '@tanstack/react-query';

import { GET_SHARED_PATIENT_DIRECTORY_SETTING } from '../../contracts/keys';
import { getSharedPatientDirectorySetting } from '../api/settings';

export { GET_SHARED_PATIENT_DIRECTORY_SETTING };

/**
 * Resolves `workspace-share_patients_enabled` for the actor's workspace.
 *
 * `data` is the strict boolean opt-in state: `true` only when the resolved
 * value is a literal `true`. An unresolved or malformed value reads as
 * not-enabled — the write path is the only place strictness matters, and the
 * section's enable flow surfaces a 409 there if this ever under-reports.
 *
 * Flag gating is the consumer's job. Pass `{ enabled }` to suppress the fetch
 * on flag-off or on-prem tenants that will short-circuit the compound gate
 * before the value is ever read (COLAB-385). The default preserves the
 * pre-existing unconditional-fetch behaviour for the settings section, which
 * mounts only when the flag is on.
 */
export function useQuerySharedPatientDirectorySetting({
  enabled = true,
}: { enabled?: boolean } = {}) {
  return useQuery({
    queryKey: [GET_SHARED_PATIENT_DIRECTORY_SETTING],
    queryFn: () => getSharedPatientDirectorySetting(),
    select: (data) => data.value === true,
    staleTime: 60 * 1000,
    enabled,
  });
}
